import { Button } from "@/components/ui/button";
import { goToShopify } from "@/lib/shopify";

/**
 * CreamProductCard — warm luxury editorial card.
 * Cream image canvas. Warm-black typography. Black accent CTA.
 */
export const CreamProductCard = ({ product, size = "default" }) => {
  if (!product) return null;
  const handleClick = () => goToShopify(product.id);

  return (
    <article
      onClick={handleClick}
      className="group cursor-pointer block"
      data-testid={`cream-card-${product.id}`}
    >
      <div className="relative aspect-square overflow-hidden bg-[#F5F0E5] mb-5 md:mb-7 transition-shadow duration-500 group-hover:shadow-[0_30px_80px_-20px_rgba(120,100,72,0.25)]">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-[1100ms] ease-out group-hover:scale-[1.04]"
        />
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/[0.025] transition-colors duration-500" />
      </div>

      <div className="text-center md:text-left">
        <h3
          className={`text-stone-900 font-display font-bold tracking-tight mb-2 ${
            size === "large" ? "text-2xl md:text-3xl" : "text-lg md:text-xl"
          }`}
        >
          {product.name}
        </h3>
        <p className="text-stone-500 text-sm md:text-base italic mb-3 line-clamp-1">
          {product.tagline}
        </p>
        <div className="flex items-center justify-center md:justify-start gap-4">
          <p className="text-stone-900 font-semibold text-base md:text-lg">
            ${product.price}
          </p>
          <span className="h-px w-6 bg-stone-400/60" aria-hidden />
          <Button
            variant="ghost"
            onClick={(e) => {
              e.stopPropagation();
              handleClick();
            }}
            className="text-stone-700 hover:text-stone-900 hover:bg-transparent p-0 h-auto text-[11px] tracking-[0.3em] uppercase font-semibold"
            data-testid={`cream-card-cta-${product.id}`}
          >
            Acquire →
          </Button>
        </div>
      </div>
    </article>
  );
};

export default CreamProductCard;
